(() => {
  if (window.ChastarAccountControls) return;
  const activeSheets = new Set();
  function resizeSheets() {
    const viewport = window.visualViewport;
    const top = Math.round(viewport?.offsetTop || 0) + 8;
    const height = Math.max(120, Math.round(viewport?.height || window.innerHeight) - 16);
    activeSheets.forEach(component => {
      if (!component.isConnected) { activeSheets.delete(component); return; }
      component.style.setProperty('--chh-account-dialog-top', top + 'px');
      component.style.setProperty('--chh-account-dialog-height', height + 'px');
    });
  }
  function closeDropdowns(except, restoreFocus = false) {
    document.querySelectorAll('[data-chh-account-dropdown][open]').forEach(dropdown => {
      if (dropdown === except) return;
      dropdown.open = false;
      if (restoreFocus) dropdown.querySelector('summary')?.focus();
    });
  }
  function init(root = document) {
    root.querySelectorAll('[data-chh-account-dropdown]').forEach(dropdown => {
      if (dropdown.dataset.chhAccountReady) return;
      dropdown.dataset.chhAccountReady = 'true';
      dropdown.addEventListener('toggle', () => { if (dropdown.open) closeDropdowns(dropdown); });
      dropdown.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          event.preventDefault(); dropdown.open = false; dropdown.querySelector('summary')?.focus();
        } else if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && event.target.closest('summary')) {
          event.preventDefault(); closeDropdowns(dropdown); dropdown.open = true;
          const links = dropdown.querySelectorAll('.chh-account-options a');
          links[event.key === 'ArrowDown' ? 0 : links.length - 1]?.focus();
        }
      });
      dropdown.addEventListener('focusout', event => { if (event.relatedTarget && !dropdown.contains(event.relatedTarget)) dropdown.open = false; });
      dropdown.querySelectorAll('.chh-account-options a').forEach(link => link.addEventListener('click', () => { dropdown.open = false; }));
    });
    root.querySelectorAll('shopify-account').forEach(component => {
      if (component.dataset.chhAccountReady) return;
      component.dataset.chhAccountReady = 'true';
      component.addEventListener('open', () => { activeSheets.add(component); closeDropdowns(); resizeSheets(); });
      component.addEventListener('close', () => { activeSheets.delete(component); });
    });
  }
  window.ChastarAccountControls = { init };
  document.addEventListener('click', event => closeDropdowns(event.target.closest('[data-chh-account-dropdown]')));
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closeDropdowns(null, true); });
  document.addEventListener('shopify:section:load', event => init(event.target));
  window.visualViewport?.addEventListener('resize', resizeSheets, { passive: true });
  window.visualViewport?.addEventListener('scroll', resizeSheets, { passive: true });
  window.addEventListener('resize', resizeSheets, { passive: true });
  init();
})();
